import {SortingAndFilteringParams} from "./../../helpers/api";
import {ManifestFilters} from "./../models/manifest";
import http from "../../common/services/httpService";
import {Api, apiUrls} from "../../helpers/api";
import {AxiosResponse} from "axios";
import {PageableModel} from "../../common/models/table";
import {ManifestDataForFileModel, ManifestDetailModel, ManifestModel} from "../models/manifest";
import {PaginationParams} from "./../../helpers/api";

export class ManifestService {
    public static async getAll(version : string, filters: ManifestFilters, paginationParams: PaginationParams, sortingAndFilteringParams: SortingAndFilteringParams): Promise<AxiosResponse<PageableModel<ManifestModel>>> {
        sortingAndFilteringParams.filterCondition = `${this.getQuery(filters)}`;
        const manifestVersion = `manifestVersion=${version}`;

        const url = Api.addParams(Api.addSortingAndFilteringParams(Api.getUrl(apiUrls.documents.manifests), sortingAndFilteringParams), manifestVersion);
        return await http.get<PageableModel<ManifestModel>>(`${Api.addPaginationParams(url, paginationParams)}`);
    }

    public static async getManifest(id: string): Promise<AxiosResponse<ManifestDetailModel>> {
        return await http.get(`${Api.getUrl(apiUrls.documents.manifestEntry)}/${id}`);
    }

    public static async getManifestDataForFile(id: string): Promise<AxiosResponse<ManifestDataForFileModel>> {
        return await http.get(`${Api.getUrl(apiUrls.documents.manifests)}/${id}/file`);
    }

    private static getQuery(filters: ManifestFilters) {
        const direction = filters.type && `direction::${(filters.type)},`;
        const shipowner = filters.shipownerId && `shipowner.entityId::${filters.shipownerId},`;
        const voyageNo = filters.voyageNo && `voyageNo::${filters.voyageNo},`;

        return direction + shipowner + voyageNo;
    }
}
